import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Composant pour injecter les données structurées Schema.org
 * Aide Google à mieux comprendre le contenu du site
 */
const StructuredData = () => {
  const areaServedMulti = [
    { '@type': 'AdministrativeArea', name: 'Hauts-de-France' },
    { '@type': 'AdministrativeArea', name: 'Pas-de-Calais' },
    { '@type': 'AdministrativeArea', name: 'Nord' },
    { '@type': 'City', name: 'Rouvroy' },
    { '@type': 'City', name: 'Lens' },
    { '@type': 'City', name: 'Liévin' },
    { '@type': 'City', name: 'Hénin-Beaumont' },
    { '@type': 'City', name: 'Carvin' },
    { '@type': 'City', name: 'Avion' },
    { '@type': 'City', name: 'Arras' },
    { '@type': 'City', name: 'Douai' },
    { '@type': 'City', name: 'Béthune' },
    { '@type': 'City', name: 'Lille' },
    { '@type': 'City', name: 'Valenciennes' },
    { '@type': 'City', name: 'Dunkerque' },
  ];

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'MedicalBusiness',
    name: 'MN Médecine Esthétique',
    description:
      'Cabinet de médecine esthétique à Rouvroy (62320), proche de Lens, Liévin et du bassin minier. Hydrafacial, lasers Fotona et Neauvia, mésothérapie, injections.',
    url: process.env.NODE_ENV === 'production'
      ? 'https://mn-medecine-esthetique.com/'
      : 'http://localhost:3000',
    logo: process.env.NODE_ENV === 'production'
      ? 'https://mn-medecine-esthetique.com/images/accueil.jpeg'
      : 'http://localhost:3000/images/accueil.jpeg',
    image: process.env.NODE_ENV === 'production'
      ? 'https://mn-medecine-esthetique.com/images/accueil.jpeg'
      : 'http://localhost:3000/images/accueil.jpeg',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '90 rue Louis Daubenton',
      addressLocality: 'Rouvroy',
      addressRegion: 'Hauts-de-France',
      postalCode: '62320',
      addressCountry: 'FR',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '50.3947',
      longitude: '2.9042',
    },
    telephone: '+33685951005',
    email: 'medesthetique@outlook.com',
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '10:00',
        closes: '18:00',
      },
    ],
    priceRange: '€€',
    medicalSpecialty: 'Cosmetic Medicine',
    areaServed: areaServedMulti,
  };

  const servicesSchema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: {
          '@type': 'Service',
          name: 'Hydrafacial',
          description: 'Soin non-invasif brevete combinant nettoyage, exfoliation, extraction et hydratation.',
          provider: {
            '@type': 'MedicalBusiness',
            name: 'MN Médecine Esthétique',
          },
          areaServed: areaServedMulti,
        },
      },
      {
        '@type': 'ListItem',
        position: 2,
        item: {
          '@type': 'Service',
          name: 'Fotona SP Dynamis',
          description: 'Systeme laser haut de gamme combinant deux longueurs d\'onde pour des traitements esthetiques et dermatologiques.',
          provider: {
            '@type': 'MedicalBusiness',
            name: 'MN Médecine Esthétique',
          },
          areaServed: areaServedMulti,
        },
      },
      {
        '@type': 'ListItem',
        position: 3,
        item: {
          '@type': 'Service',
          name: 'mesotherapie',
          description: 'Technique d\'injection de micro-doses de substances actives directement dans le derme pour revitaliser la peau.',
          provider: {
            '@type': 'MedicalBusiness',
            name: 'MN Médecine Esthétique',
          },
          areaServed: areaServedMulti,
        },
      },
    ],
  };

  const physiciansSchema = [
    {
      '@context': 'https://schema.org',
      '@type': 'Physician',
      name: 'Dr Massinissa GHELBOUN',
      jobTitle: 'Médecin Urgentiste & Médecine Esthétique',
      worksFor: {
        '@type': 'MedicalBusiness',
        name: 'MN Médecine Esthétique',
      },
      identifier: {
        '@type': 'PropertyValue',
        name: 'RPPS',
        value: '10100953586',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'Physician',
      name: 'Dr Nacer GHELBOUN',
      jobTitle: 'Médecin Généraliste & Médecine Esthétique',
      worksFor: {
        '@type': 'MedicalBusiness',
        name: 'MN Médecine Esthétique',
      },
      identifier: {
        '@type': 'PropertyValue',
        name: 'RPPS',
        value: '10100732824',
      },
    },
  ];

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'La medecine esthetique a Rouvroy convient-elle a tous les types de peau ?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Oui. Les protocoles sont adaptes selon le type de peau et les objectifs de chaque patient.',
        },
      },
      {
        '@type': 'Question',
        name: 'Combien de seances faut-il pour l epilation laser ?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Le nombre de seances depend de la zone et du phototype. Un plan personnalise est defini lors de la consultation.',
        },
      },
      {
        '@type': 'Question',
        name: 'Proposez-vous des soins de medecine esthetique pres de Lens et Hénin-Beaumont ?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Oui, le cabinet de Rouvroy accueille des patientes et patients de Lens, Hénin-Beaumont, Liévin et des environs du Pas-de-Calais.',
        },
      },
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(servicesSchema)}
      </script>
      {physiciansSchema.map((physician) => (
        <script key={physician.name} type="application/ld+json">
          {JSON.stringify(physician)}
        </script>
      ))}
      <script type="application/ld+json">
        {JSON.stringify(faqSchema)}
      </script>
    </Helmet>
  );
};

export default StructuredData;

